import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBrush = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 20,
	viewBox: "0 0 22 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.99912 12.2233C4.15493 12.2233 2.66625 13.712 2.66625 15.5562C2.66625 17.0115 1.37754 17.7781 0.444336 17.7781C1.46642 19.1335 3.21062 20 4.88816 20C7.34338 20 9.33199 18.0114 9.33199 15.5562C9.33199 13.712 7.84331 12.2233 5.99912 12.2233ZM21.2303 1.81364L19.7417 0.324955C19.3084 -0.108318 18.6085 -0.108318 18.1752 0.324955L8.22103 10.2791L11.2762 13.3343L21.2303 3.38009C21.6636 2.94681 21.6636 2.24691 21.2303 1.81364Z",
		fill: "#5A7481"
	})
});
export default SvgBrush;
